import { render } from "./RoadStageFIASpecsRules.vue?vue&type=template&id=c3efa80e"
import script from "./RoadStageFIASpecsRules.vue?vue&type=script&lang=js"
export * from "./RoadStageFIASpecsRules.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__